import { FileValidatorT } from '@/types/common';

export const FILE_VALIDATORS: FileValidatorT = {
    image: {
        maxFilesCount: 10,
        maxSize: 15,
        accept: ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
    },
};
